import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Translate } from 'core/translate';
import { SvgIcon } from 'core/icons';
import { withNotifications } from '../../common/notifications/NotificationsContext';
import { Dagger } from '../../common/notifications/NotificationsTrigger';

class AttributesNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slideIndex: 0
    };
    this.previous = this.previous.bind(this);
    this.next = this.next.bind(this);
  }

  previous() {
    if (this.state.slideIndex === 0) {
      this.setState({ slideIndex: 0 });
    } else this.setState({ slideIndex: this.state.slideIndex - 1 });
  }

  next() {
    if (this.state.slideIndex === this.props.attributes.length) {
      this.setState({ slideIndex: 0 });
    } else this.setState({ slideIndex: this.state.slideIndex + 1 });
  }

  renderPreviousButton() {
    const { slideIndex } = this.state;
    return (
      <button
        className={`attributes-carousel__control--previous stat-arrow-prev ${
          slideIndex === 0 ? 'invisible' : ''
        }`}
        data-dtm="attributes"
        onClick={this.previous}>
        <SvgIcon name="chevron-left" />
        <span className="show-for-sr">
          <Translate value="byo.page.general.prev.step" />
        </span>
      </button>
    );
  }

  renderNextButton() {
    const { attributes } = this.props;
    const { slideIndex } = this.state;
    return (
      <button
        className={`attributes-carousel__control--next stat-arrow-next ${
          slideIndex === attributes.length ? 'invisible' : ''
        }`}
        data-dtm="attributes"
        onClick={this.next}>
        <SvgIcon name="chevron-right" />
        <span className="show-for-sr">
          <Translate value="byo.page.general.next.step" />
        </span>
      </button>
    );
  }

  renderAttributes() {
    const { attributes } = this.props;
    const { slideIndex } = this.state;
    return attributes
      .filter((attribute, index) => slideIndex === index)
      .map(attribute => {
        return (
          <li className="attribute-carousel__slide" key={attribute.id}>
            <div className="attributes-carousel__label">
              <span>
                {this.renderLabel(attribute, attribute.unit === 'MPG')}
                <AttributesDisclaimer
                  text={`${attribute.value} `}
                  disclaimer={attribute.disclosure}
                />
              </span>
            </div>
          </li>
        );
      });
  }

  renderLabel(attribute, hidden) {
    return (
      <span>
        {attribute.name}{' '}
        {hidden ? null : (
          <span className="attributes-carousel__unit">{attribute.unit}</span>
        )}
        :
      </span>
    );
  }

  render() {
    const { attributes, selections } = this.props;
    const { driveType, bodyTypeId, engine } = selections;
    const { slideIndex } = this.state;
    const searchParams = new URLSearchParams({
      section: 'Trailering and Payload',
      engineOne: engine,
      driveTypeOne: driveType,
      bodyTypeOne: bodyTypeId
    });

    return (
      <div
        className="attributes-carousel"
        role="region"
        aria-label="Vehicle Attributes">
        {this.renderPreviousButton()}

        <ol className="attributes-carousel__box">
          {this.renderAttributes()}

          {slideIndex !== attributes.length ? null : (
            <li className="attribute-carousel__slide">
              <Link
                to={`/config/compare/capabilities?${searchParams.toString()}`}
                className="attributes-carousel__link">
                <Translate value="view.all.specs" />
              </Link>
            </li>
          )}
        </ol>
        {this.renderNextButton()}
      </div>
    );
  }
}

const AttributesDisclaimer = withNotifications(
  ({ text, disclaimer, notifications }) => {
    const { disabled, show } = notifications;

    if (disabled || !disclaimer) {
      return <span className="attributes-carousel__value">{text}</span>;
    }

    return (
      <React.Fragment>
        <span
          className="attributes-carousel__value disclaimer"
          onClick={event => show(disclaimer, event)}>
          {text} <Dagger />
        </span>
        <span className="show-for-sr">{disclaimer}</span>
      </React.Fragment>
    );
  }
);

export default AttributesNav;
